import { PermissoesService } from './../../../service/usuario/permissoes.service';
import { ResponsePageable } from 'app/model/cliente/pageable/responsePageable.model';
import { Component, OnInit, ViewChild, ElementRef } from '@angular/core';
import { TipoReajusteModel } from 'app/model/cliente/tiporeajuste.model';
import { TiporeajusteService } from 'app/service/cliente/tiporeajuste.service';
import * as CryptoJS from 'crypto-js';
import { MatSnackBar, MatSnackBarHorizontalPosition, MatSnackBarVerticalPosition } from '@angular/material/snack-bar';

@Component({
  selector: 'app-tiporeajuste',
  templateUrl: './tiporeajuste.component.html',
  styleUrls: ['./tiporeajuste.component.scss']
})
export class TiporeajusteComponent implements OnInit {

  public submit = false;
  public loading = true;
  tipoReajuste = {} as TipoReajusteModel;
  tipoReajustes: TipoReajusteModel[];

  public page : ResponsePageable;

  public pageAtual = 0;

  public edited = false;
  public editado = false;
  public errorAlert = false;
  public successDelete = false;

  public arrayString: string;
  public creatorTipoReajuste = false;
  public editorTipoReajuste = false;
  public listaTipoReajuste = false;
  public deletaTipoReajuste = false;
  public superUser = false;
  horizontalPosition: MatSnackBarHorizontalPosition = 'right';
  verticalPosition: MatSnackBarVerticalPosition = 'top';

  @ViewChild('cardEdit') targetEl: ElementRef;
  @ViewChild('tipoReajusteDescricao') tipoReajusteDescricao: ElementRef;
  @ViewChild('tipoReajustePrazo') tipoReajustePrazo: ElementRef;

  constructor(private tipoReajusteService: TiporeajusteService,
    private _snackBar: MatSnackBar,
    private permissionService: PermissoesService) { }

  ngOnInit() {
    this.listTipoReajuste(0, 10);
    this.getAuthority();
  }

  listarTipoReajuste(){
    this.tipoReajusteService.getTipoReajuste().subscribe(data =>{
      this.tipoReajustes = data.content;
    })
  }

  scroll() {
    this.targetEl.nativeElement.scrollIntoView();
  }

  changePage(event){
    this.listTipoReajuste(event.page, event.size);
    this.pageAtual = event.page;
   }

   onSubmit(){
     this.submit = true;
   }

   postSubmit(){
    this.submit = false;
    this.tipoReajusteDescricao.nativeElement.value = "";
    this.tipoReajustePrazo.nativeElement.value = " ";
    this.tipoReajuste.descricao = null;
    this.tipoReajuste.prazo = null;
  }

  listTipoReajuste(page, size){
    this.tipoReajusteService.getPageTipoReajuste(page, size).subscribe(res => {
      this.page = res;
      this.tipoReajustes = this.page.content;
      this.loading = false;
    });
  }

  saveOrEdit() {
    if (this.tipoReajuste.id !== undefined) {
      this.putTipoReajuste();
    } else {
      this.cadastrarTipoReajuste();
    }
  }

  putTipoReajuste() {
    this.tipoReajusteService.putTipoReajuste(this.tipoReajuste).subscribe(() => {
      this.tipoReajuste = new TipoReajusteModel();
      this.listTipoReajuste(this.pageAtual, 10);
      this.openSnackBarSuccess('Tipo de Reajuste atualizado com sucesso !');
      this.postSubmit();
    }, err => {
      console.error(err);
      this.openSnackBarError('Erro ao tentar atualizar o Tipo de Reajuste !');
    });
  }

  cadastrarTipoReajuste() {
    this.tipoReajusteService.postTipoReajuste(this.tipoReajuste).subscribe(tipoReajuste => {
        this.tipoReajuste = new TipoReajusteModel();
        this.listTipoReajuste(0, 10);
        this.openSnackBarSuccess('Tipo de Reajuste salvo com sucesso !');
        this.postSubmit();
    } , err => {
      console.log(err);
      this.openSnackBarError('Erro ao tentar adicionar o Tipo de Reajuste');
    });
  }

  editarTipoReajuste(tipoReajuste: TipoReajusteModel){
    this.tipoReajuste = { ...tipoReajuste}
  }

  confirmeExclusao(id: number){
    var confirme = confirm('Tem certeza que deseja excluir este tipo de reajuste ?');
    if(confirme == true) {
      this.deleteTipoReajuste(id);
    } else {
      console.log("Cancelou exclusão!");
    }
  }

  deleteTipoReajuste(id:number) {
    this.tipoReajusteService.deleteTipoReajuste(id).subscribe(tipoReajuste => {
        this.tipoReajuste = new TipoReajusteModel();
        this.listTipoReajuste(0, 10);
        this.openSnackBarSuccess('Tipo de Reajuste excluído com sucesso !');
    }, err => {
      if(err.status == 500){
        this.openSnackBarError('Erro ao excluir! Este tipo de reajuste está sendo usado por um cliente.');
      }
      console.log('error', err.status);
    })

  }

  getAuthority() {
    this.getItemAuthority('authority');
    if (this.arrayString.includes('ADD_EMPRESA')) {
      this.creatorTipoReajuste = true;
    }
    if (this.arrayString.includes('EDIT_EMPRESA')) {
      this.editorTipoReajuste = true;
    }
    if (this.arrayString.includes('LIST_EMPRESA')) {
      this.listaTipoReajuste = true;
    }
    if (this.arrayString.includes('DELETE_EMPRESA')) {
      this.deletaTipoReajuste = true;
    }
    if (this.arrayString.includes('SUPER_USER')) {
      this.superUser = true;
    }
  }

  getItemAuthority(key) {
    const store = sessionStorage.getItem(key);
    if (store) {
      try {
        const bytes = CryptoJS.AES.decrypt(
          store,
          sessionStorage.getItem('ticket-ECM')
        );
        this.arrayString = JSON.parse(bytes.toString(CryptoJS.enc.Utf8));
        return this.arrayString;
      } catch (e) {
        sessionStorage.clear();
      }
    }

    return null;
  }

// SnackBares
openSnackBarSuccess(message: string) {
  this._snackBar.open(message, '', {
    horizontalPosition: this.horizontalPosition,
    verticalPosition: this.verticalPosition,
    duration: 4000,
    panelClass: ['success-snackbar']
  });
}

openSnackBarError(message: string) {
  this._snackBar.open(message,'', {
    horizontalPosition: this.horizontalPosition,
    verticalPosition: this.verticalPosition,
    duration: 3000,
    panelClass: ['error-snackbar']
  });
}

}



// WEBPACK FOOTER //
// /app/src/app/components/cliente-components/tiporeajuste/tiporeajuste.component.ts